/**
 * Creates a new object by copying the provided object and removing the specified properties.
 *
 * The original object remains unchanged. The returned object contains all properties
 * from the source object except those listed in the keys array.
 *
 * @template T - The type of the source object.
 * @template K - The keys of the source object that should be omitted.
 *
 * @param obj - The object from which properties should be removed.
 * @param keys - An array of property keys to exclude from the returned object.
 *
 * @returns A new object without the specified properties.
 */

export function omit<T, K extends keyof T>(obj: T, keys: readonly K[]): Omit<T, K> {
  const copy = { ...obj };

  keys.forEach(key => delete copy[key]);

  return copy;
}
